module.exports = __webpack_public_path__ + "img/uk_flag.b0507e23.png";